// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".titleLabel[data-v-479a495f] {\n  font-size: 16px;\n  color: #00A551;\n  font-weight: 600;\n  margin-bottom: 15px;\n  cursor: pointer;\n}\n[data-v-479a495f] .el-descriptions-item__cell {\n  font-size: 14px;\n  color: #000000;\n  font-weight: 600 !important;\n}\n[data-v-479a495f] .el-descriptions-item__cell div {\n  font-size: 14px;\n  color: #000000;\n  font-weight: 400 !important;\n}", ""]);
// Exports
module.exports = exports;
